// extracted by mini-css-extract-plugin
export default {"container":"container--GUKW1","layout":"layout--jgsO2","body":"body--WIzoD","stickyFooter":"stickyFooter--m9IYj"};